import { apiClient } from "../config";

async function updateUserProfile(personId:any,payload: any) {
  const res = await apiClient.put(`/admin/users/person/${personId}`, payload);
  return res.data;
}

export default updateUserProfile;
